/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type FiltersModalUpdateLabelGroupMutationVariables = {|
  id: string,
  name: string,
  labels?: ?$ReadOnlyArray<?string>,
|};
export type FiltersModalUpdateLabelGroupMutationResponse = {|
  +labelGroupUpdate: ?{|
    +labelGroup: ?{|
      +id: string,
      +name: string,
      +labels: ?{|
        +edges: $ReadOnlyArray<?{|
          +node: ?{|
            +id: string,
            +name: string,
          |}
        |}>
      |},
    |}
  |}
|};
export type FiltersModalUpdateLabelGroupMutation = {|
  variables: FiltersModalUpdateLabelGroupMutationVariables,
  response: FiltersModalUpdateLabelGroupMutationResponse,
|};
*/


/*
mutation FiltersModalUpdateLabelGroupMutation(
  $id: ID!
  $name: String!
  $labels: [String]
) {
  labelGroupUpdate(input: {id: $id, name: $name, labels: $labels}) {
    labelGroup {
      id
      name
      labels {
        edges {
          node {
            id
            name
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name",
    "type": "String!"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "labels",
    "type": "[String]"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "labels",
            "variableName": "labels"
          },
          {
            "kind": "Variable",
            "name": "name",
            "variableName": "name"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "LabelGroupUpdatePayload",
    "kind": "LinkedField",
    "name": "labelGroupUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "LabelGroupNode",
        "kind": "LinkedField",
        "name": "labelGroup",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "LabelNodeConnection",
            "kind": "LinkedField",
            "name": "labels",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LabelNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LabelNode",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FiltersModalUpdateLabelGroupMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FiltersModalUpdateLabelGroupMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "FiltersModalUpdateLabelGroupMutation",
    "operationKind": "mutation",
    "text": "mutation FiltersModalUpdateLabelGroupMutation(\n  $id: ID!\n  $name: String!\n  $labels: [String]\n) {\n  labelGroupUpdate(input: {id: $id, name: $name, labels: $labels}) {\n    labelGroup {\n      id\n      name\n      labels {\n        edges {\n          node {\n            id\n            name\n          }\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'dfc85587078e326fc17593892a02924d';

module.exports = node;
